import { defineStore } from 'pinia';
import $api from '@/plugins/axios';
import { useAuthStore } from '@/store/auth.store';

export const useAdminStore = defineStore('AdminStore', {
  state: () => {
    return {
      activeHistory: {}
    };
  },
  actions: {
    async deleteAcademy(groupAcademyId) {
      const res = await $api.delete('/admin/group-academies', {params: {groupId: groupAcademyId}});
      console.log(res)
    },
    async deleteStudentCustomer(params) {
      const res = await $api.delete('/admin/customers/students', {params});
      console.log(res)
    },
    async executeCleanAuthMeta() {
      const res = await $api.post('/admin/executes/clean-auth-meta');
      console.log(res)
    },
    async executeSubscriptionPaymentsForNextMonth() {
      const res = await $api.post('/admin/executes/subscription-payments-for-next-month');
      console.log(res)
    },
    async executeUpdateSubscriptionMembers() {
      const res = await $api.post('/admin/executes/update-subscription-members');
      console.log(res)
    },
    async getSubscriptions(params) {
      return await $api.get(`/admin/subscriptions`, {params});
    },
    async terminateSubscription(params) {
      return await $api.delete(`/admin/subscriptions/${params.subscriptionId}`);
    },
    async getPaymentHistory(params) {
      return await $api.get(`/admin/subscriptions/${params.subscriptionId}/histories`, {params})
    },
    async executeCancelPayment(params) {
      return await $api.post(`/admin/subscriptions/payment/${params.merchantUid}`, params)
    },
    async getPayment(params) {
      return await $api.get(`/admin/subscriptions/payment/${params.merchantUid}`)
    },
    async executeMigrationCamstudyUsers(params) {
      return await $api.post(`/admin/migration/students`, params)
    },
    async saveUserStudyTimeStatsByDate(params) {
      return await $api.post(`/admin/user/aggregate-study-time-stats`, params)
    },
    async saveRoomStudyTimeStatsByDate(params) {
      return await $api.post(`/admin/room/aggregate-study-time-stats`, params)
    },
    async deleteUserStudyTimeStatsByDate(params) {
      return await $api.delete(`/admin/user/aggregate-study-time-stats`, {params})
    },
    async deleteRoomStudyTimeStatsByDate(params) {
      return await $api.delete(`/admin/room/aggregate-study-time-stats`, {params})
    },
    async getActivationHistories(params) {
      try {
        this.activeHistory = await $api.get('/admin/customers/activation-histories', { params })
      }catch (e) {
        if(e.response.status === 400){
          this.$alert({type: 'warning', message: '데이터가 많아 조회에 실패했습니다'})
        }
      }
    },
    async switchGroupSpace(params) {
      const res = await $api.post('/admin/groups/switch-group', params);
      const accessToken = res?.data?.accessToken;
      if (accessToken) {
        useAuthStore().setAccessToken(accessToken)
      }
      return accessToken;
    }
  },
  getters: {},
});
